import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

// Components
import Lang from '../Lang';

// Styles
import styles from './MobileView.styl';

const cx = classNames.bind(styles);

export default function MobileView(props) {
  const { className, locales, currentLocale, onLocaleChange } = props;

  return (
    <div className={cx('LangSwitcher', className)}>
      {locales.map(locale => (
        <Lang
          key={locale}
          locale={locale}
          onLocaleClick={onLocaleChange}
          isActive={locale === currentLocale}
        />
      ))}
    </div>
  );
}

MobileView.defaultProps = {
  className: '',
};

MobileView.propTypes = {
  className: PropTypes.string,
  currentLocale: PropTypes.string.isRequired,
  onLocaleChange: PropTypes.func.isRequired,
  locales: PropTypes.array.isRequired,
};
